const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 10px',
    borderBottom: '1px solid #DFE2E5',
    height: 50,
  },
  input: {
    height: '99%',
    width: '100%',
    maxWidth: '80%',
    border: 'none',
    transition: 'max-width 0.3s',
    paddingLeft: 10,
    '&:focus': {
      outline: 'none',
      maxWidth: '100%',
    },
  },
  inputFilled: {
    maxWidth: '100%',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatSearch/styles.js